module.exports = __webpack_public_path__ + "img/unknown-email.2fc800dc.svg";